import React from "react";
import { RefundLast } from "../Components";

export const RefundLastPage = () => {
  return <RefundLast />;
};
